<form [formGroup]="empreendimentoForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Dados do Empreendimento</h2>
      <div class="form-group">
        <span class="icon loja"></span>
        <div class="inputs">
          <label for="dataInicioAtividade">Data início do negócio</label>
          <app-input-date formControlName="dataInicioAtividade" [format]="'MM/YYYY'"></app-input-date>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="dataInicioPonto">Data início no local</label>
          <app-input-date formControlName="dataInicioPonto" [format]="'MM/YYYY'"></app-input-date>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="concorrencia">Existe concorrência ao seu negócio?</label>
          <select
              class="form-control"
              appShowErrorMessages
              name="concorrencia"
              formControlName="concorrencia">
          <option value="" selected hidden>Selecione...</option>
          <option value="1">NÃO EXISTE</option>
          <option value="2">EXISTEM POUCOS</option>
          <option value="3">EM CRESCIMENTO</option>
          <option value="4">EXISTEM MUITOS</option>
        </select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>O negócio representa renda</label>
          <app-button-select formControlName="tipoRenda">
            <app-button-select-item value="P" title="Principal"></app-button-select-item>
            <app-button-select-item value="C" title="Complementar"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>Local de funcionamento</label>
          <app-button-select formControlName="localFuncionamento">
            <app-button-select-item value="R" title="Na residência"></app-button-select-item>
            <app-button-select-item value="F" title="Fora da residência"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>Ponto comercial</label>
          <app-button-select formControlName="tipoPontoComercial">
            <app-button-select-item value="1" title="Próprio"></app-button-select-item>
            <app-button-select-item value="2" title="Alugado"></app-button-select-item>
            <app-button-select-item value="3" title="Posse regurar/irregular"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>Setor econômico</label>
          <app-button-select formControlName="setorEconomico">
            <app-button-select-item value="C" title="Comércio"></app-button-select-item>
            <app-button-select-item value="P" title="Produção"></app-button-select-item>
            <app-button-select-item value="S" title="Serviço"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>Houve mudança na atividade?</label>
          <app-button-select formControlName="flagMudancaAtividade">
            <app-button-select-item value="S" title="Sim"></app-button-select-item>
            <app-button-select-item value="N" title="Não"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon credito"></span>
        <div class="inputs">
          <label>Possui experiência creditícia?</label>
          <app-button-select formControlName="flagExperienciaCrediticia">
            <app-button-select-item value="S" title="Sim"></app-button-select-item>
            <app-button-select-item value="N" title="Não"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group" *ngIf="empreendimentoForm.get('flagExperienciaCrediticia').value === 'S'">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>Possui crédito?</label>
          <app-button-select formControlName="flagCreditoAtivo">
            <app-button-select-item value="S" title="Sim"></app-button-select-item>
            <app-button-select-item value="N" title="Não"></app-button-select-item>
          </app-button-select>
        </div>
      </div>
      <div class="form-group" *ngIf="empreendimentoForm.get('flagCreditoAtivo').value === 'S'">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label>Em quais instituições?</label>
          <app-instituicao-base [formulario]="instituicoesForm"></app-instituicao-base>
        </div>
      </div>

    </div>
  </div>
</form>

<app-botao-navegacao
(previous)="onClickPrevious()"
(next)="onClickNext()"
[previousShow]="true"
[nextShow]="true"
[nextEnabled]="empreendimentoForm.valid">
</app-botao-navegacao>
